// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__r-BUY","colMaxWidth":"Table_colMaxWidth__2Nnz3"};